<template>
  <div>
    <div class="vx-row">
      <!-- MULTIPLE COLUMNS-->
      <div class="vx-col w-3/4 mb-base">
        <vx-card title="">
          <div class="demo-alignment">
            <v-select
              :value="selected"
              v-model="selected"
              @input="ps"
              :options="options"
              style="width: 200px"
            ></v-select>
            <vs-button
              @click="iadeCek(0)"
              style="border-radius: 5px"
              color="success"
              id="button-with-loading-yeni-iade"
              class="vs-con-loading__container"
              type="gradient"
              >İade Çek</vs-button
            >
          </div>
          <div class="demo-alignment">
            <vs-input
              class="inputx"
              placeholder="Barkod"
              @keyup.enter="barkodOku(0)"
              id="barkodM"
              :ref="barkod"
              v-model="barkod"
            />
            <vs-button
              @click="siparisSec()"
              style="border-radius: 5px"
              type="gradient"
              >İade Seç</vs-button
            >
            <vs-button
              @click="listeTemizle()"
              style="border-radius: 5px"
              color="danger"
              type="gradient"
              >Liste Temizle</vs-button
            >
          </div>
        </vx-card>

        <vx-card title="" style="margin-top: 10px">
          <vs-table :data="sipariseGoreUrunListesi">
            <template slot="thead">
              <vs-th sort-key="stokkodu">Stok Kodu</vs-th>

              <vs-th>Stok Adı</vs-th>
              <vs-th>İade Ret Durumu</vs-th>
              <vs-th></vs-th>
              <vs-th>İşlem Durumu</vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr state="" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="data[indextr].merchantSku">
                  {{ data[indextr].merchantSku }}
                </vs-td>

                <vs-td :data="data[indextr].stokAdi">
                  {{ data[indextr].stokAdi }}
                </vs-td>
                <vs-td :data="data[indextr].stokAdi">
                  <vs-button
                    @click="
                      redListesi(
                        data[indextr].orderNumber,
                        data[indextr].lineItemId,
                        indextr
                      )
                    "
                    color="success"
                    type="filled"
                    >Red Nedeni</vs-button
                  >
                  <br /><span class="font-medium text-danger cursor-pointer">{{
                    data[indextr].iadeNedeni
                  }}</span>
                </vs-td>
                <vs-td>
                  <span
                    v-if="
                      (data[indextr].iadeNedeni != '') &
                      (data[indextr].iadeNedeni != null)
                    "
                  >
                    <vs-button
                      @click="
                        talebiGonder(
                          data[indextr].orderNumber,
                          data[indextr].lineItemId
                        )
                      "
                      color="red"
                      type="filled"
                      >Talebi Gönder</vs-button
                    >
                  </span>
                </vs-td>
                <vs-td :data="data[indextr].durum">
                  <span v-if="data[indextr].kabul == '0'">
                    <vs-button
                      @click="
                        kabulListesineEkle(
                          data[indextr].orderNumber,
                          data[indextr].claimItemId,
                          1
                        )
                      "
                      color="success"
                      type="filled"
                      >Kabul Listesine Ekle</vs-button
                    >
                  </span>
                  <span v-if="data[indextr].kabul == '1'">
                    <vs-button
                      @click="
                        kabulListesineEkle(
                          data[indextr].orderNumber,
                          data[indextr].claimItemId,
                          0
                        )
                      "
                      color="red"
                      type="filled"
                      >Kabul Listesinden Çıkar</vs-button
                    >
                  </span>
                </vs-td>
              </vs-tr>

              <vs-tr>
                <vs-td> </vs-td>
                <vs-td> </vs-td>
                <vs-td> </vs-td>
                <vs-td> </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vx-card>
      </div>

      <div class="vx-col w-1/4 mb-base">
        <vx-card>
          <p class="text-grey mb-3">Sipariş Detayları</p>
          <div class="flex justify-between">
            <span class="font-semibold">Sipariş No</span>
            <span class="font-medium text-danger cursor-pointer">{{
              genelSiparisNo
            }}</span>
          </div>
          <div class="flex justify-between">
            <span class="font-semibold">Fatura No</span>
            <span class="font-medium text-danger cursor-pointer">{{
              faturaNo
            }}</span>
          </div>
          <div class="flex justify-between">
            <span class="font-semibold">Kargo</span>
            <span class="font-medium text-danger cursor-pointer">{{
              genelKargoAdi
            }}</span>
          </div>

          <div class="flex justify-between">
            <span class="font-semibold">Kargo Numarası</span>
            <span class="font-medium text-danger cursor-pointer">{{
              genelKargoNo
            }}</span>
          </div>

          <div class="flex justify-between">
            <span class="font-semibold">Müşteri</span>
            <span class="font-medium text-danger cursor-pointer">{{
              genelMusteri
            }}</span>
          </div>

          <vs-divider />
          <div class="flex justify-between mb-2">
            <vs-button
              id="button-with-loading"
              class="w-full vs-con-loading__container"
              @click="iadefaturaOlustur()"
              style="height: 70px"
              >İşlemleri Tamamla</vs-button
            >
          </div>
        </vx-card>
      </div>
    </div>

    <div class="vx-row">
      <!-- MULTIPLE COLUMNS-->

      <div class="vx-col w-3/4 mb-base"></div>

      <div class="vx-col w-1/4 mb-base">
        <vx-card title=""> </vx-card>
      </div>
    </div>

    <vs-popup
      fullscreen
      class="holamundo"
      title="İade"
      :active.sync="popupActiveSiparis"
    >
      <table>
        <tr>
          <td>
            <vs-input
              class="inputx"
              style="width: 400px"
              placeholder="Sipariş No, Takip No, Ad, Soyad ile arama yapabilirsiniz."
              @keyup.enter="siparisBul()"
              :ref="siparisBulOrderNumber"
              v-model="siparisBulOrderNumber"
            />
          </td>
        </tr>
      </table>

      <vs-table :data="listSiparis">
        <template slot="thead">
          <vs-th sort-key="stokkodu">Sipariş No</vs-th>
          <vs-th sort-key="stokkodu">Müşteri Ad Soyad</vs-th>
          <vs-th sort-key="stokkodu">Kargo No</vs-th>

          <vs-th>Seç</vs-th>
          <vs-th>Sil</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].orderNumber">
              {{ data[indextr].orderNumber }}
            </vs-td>
            <vs-td :data="data[indextr].customerFirstName">
              {{ data[indextr].customerFirstName }}
              {{ data[indextr].customerLastName }}
            </vs-td>
            <vs-td :data="data[indextr].cargoTrackingNumber">
              {{ data[indextr].cargoTrackingNumber }}
            </vs-td>

            <vs-td>
              <vs-button
                @click="
                  siparisHazirla(
                    data[indextr].orderNumber,
                    data[indextr].cargoTrackingNumber,
                    data[indextr].partiNo
                  )
                "
                color="success"
                type="filled"
                >Seç</vs-button
              >
            </vs-td>

            <vs-td>
              <vs-button
                @click="secilenSiparisSil(data[indextr].orderNumber)"
                color="red"
                type="filled"
                >Sil</vs-button
              >
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vs-popup>

    <vs-popup
      fullscreen
      class="holamundo"
      title="İade Nedenleri"
      :active.sync="popupActiveCikti"
    >
      <div class="vx-row">
        <div class="vx-col w-2/4 mb-base">
          <vs-table :data="listSiparis">
            <template slot-scope="{ data }">
              <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="data[indextr].name">
                  {{ data[indextr].name }}
                </vs-td>

                <vs-td>
                  <vs-button
                    @click="
                      lineIadeNedeniYaz(data[indextr].name, data[indextr].id)
                    "
                    color="success"
                    type="filled"
                    >Seç</vs-button
                  >
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>

        <div class="vx-col w-2/4 mb-base">
          <table>
            <tr>
              <td>İade Notunuz</td>
            </tr>
            <tr>
              <td>
                <vs-textarea
                  counter="500"
                  label="İade Red Nedeniniz"
                  :counter-danger.sync="counterDanger"
                  v-model="iadeTextarea"
                />
              </td>
            </tr>
            <tr>
              <td>
                <div v-if="!image">
                  <h2>Resim Seç</h2>
                  <input type="file" @change="onFileChange" />
                </div>
                <div v-else>
                  <img :src="image" />
                  <button @click="removeImage">Resim Sil</button>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <vs-table :data="listImage">
                  <template slot-scope="{ data }">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                      <vs-td :data="data[indextr].name">
                        {{ data[indextr].resimAdi }}
                      </vs-td>
                      <vs-td :data="data[indextr].name">
                        <img
                          style="width: 50px"
                          v-bind:src="
                            imageUrl.replace('sistem.asmx?WSDL', 'uploads/') +
                            data[indextr].resimAdi
                          "
                          alt=""
                        />
                      </vs-td>

                      <vs-td>
                        <vs-button
                          @click="
                            imageDelete(
                              data[indextr].id,
                              data[indextr].resimAdi
                            )
                          "
                          color="red"
                          type="filled"
                          >Sil</vs-button
                        >
                      </vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import vSelect from "vue-select";
import state from "../../store/state";
import Store from "../../store/store";
import { fixTurkishCharsDeep } from "../../helpers/fixTurkishChars";

export default {
  components: {
    "v-select": vSelect,
  },
  data() {
    return {
      options: [
        "Tümü",
        "Ciceksepeti",
        "Gittigidiyor",
        "Hepsiburada",
        "Trendyol",
        "N11",
        "Morhipo",
        "Shopify",
        "Ticimax",
        "Modanisa",
        "Ikas",
        "LcWaikiki",
        "Beymen",
        "Boyner",
        "Sopyo",
      ],
      optionsParti: [],
      pazaryeriTum: [],
      list: [],
      listSonFaturalar: [],
      listSiparis: [],
      sipariseGoreUrunListesi: [],
      listImage: [],
      progress: 0,
      activePrompt: false,
      pazaryeriVal: "",
      partiVal: "",
      toplamParca: 0,

      selected: { id: 0, label: "İade Firması" },
      iadeModel: { id: 0, label: "İade red" },
      selectedParti: { id: 0, label: "Parti Nolar" },
      popupActive: false,
      popupFatura: false,
      popupActiveSiparis: false,
      popupActiveCikti: false,
      barkod: "",
      siparisBulOrderNumber: "",
      genelSiparisNo: "",
      faturaNo: "",
      genelKargoAdi: "",
      genelKargoNo: "",
      genelMusteri: "",
      hediyeMi: 0,
      genelToplam: 0,
      eklenenDeger: "",
      indext: 0,
      indext1: 0,
      urunResim: "",
      validated: 1,
      validatedF: 1,
      siparisToplamParca: 0,
      eklenenToplamParca: 0,
      askiDurumu: false,
      aski: 0,
      imageLink: "",
      ciktiListesi: [],
      jsonD: "",
      dr: "",
      popupActiveFaturaCikti: false,
      receiptId: 0,
      faturaNo: "",
      ilkOkuma: 0,
      recId: 0,
      total: 0,
      faturaAranan: "",
      faturaBulOrderNumber: "",
      im: 0,
      iadeOrderNumber: "",
      iadeLineItemId: "",
      iadeTextarea: "",
      counterDanger: false,
      image: "",
      imageUrl: state.sistemAddress,
    };
  },
  methods: {
    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createImage(files[0]);
    },
    createImage(file) {
      var image = new Image();
      var reader = new FileReader();
      var vm = this;
      //console.log(reader)
      reader.onload = (e) => {
        vm.image = e.target.result;

        vm.upload(e.target.result, file.name);
      };
      reader.readAsDataURL(file);
    },
    removeImage: function (e) {
      this.image = "";
    },
    upload(f, fileName) {
      var vm = this;
      var vs = this.$vs;
      const soap = require("soap");
      let url = state.sistemAddress;
      url = url.replace("sistem", "upload");
      const args = {
        f: f,
        orderNumber: this.iadeOrderNumber,
        lineItemId: this.iadeLineItemId,
        fileName: fileName,
      };
      soap.createClient(url, function (err, client) {
        client.uploadFile(args, function (err, result) {
          console.log(result.uploadFileResult);
          if (result.uploadFileResult == "Ok") {
            vm.removeImage();
            vm.imageList();
          }
          //vm.veriler=fixTurkishCharsDeep(JSON.parse(result.iadeKabulListesineEkleResult))
          //vm.barkodOku(orderNumber.trim())
        });
      });
    },
    imageList() {
      var vm = this;
      var vs = this.$vs;
      const soap = require("soap");
      let url = state.sistemAddress;
      url = url.replace("sistem", "upload");
      const args = {
        orderNumber: this.iadeOrderNumber,
        lineItemId: this.iadeLineItemId,
      };
      soap.createClient(url, function (err, client) {
        client.fileList(args, function (err, result) {
          // console.log(result.fileListResult)

          vm.veriler = JSON.parse(result.fileListResult);
          vm.listImage = vm.veriler;
          //vm.barkodOku(orderNumber.trim())
        });
      });
    },
    imageDelete(id, fileName) {
      var vm = this;
      var vs = this.$vs;
      const soap = require("soap");
      let url = state.sistemAddress;
      url = url.replace("sistem", "upload");
      const args = {
        orderNumber: this.iadeOrderNumber,
        lineItemId: this.iadeLineItemId,
        id: id,
        fileName: fileName,
      };
      soap.createClient(url, function (err, client) {
        client.imageDelete(args, function (err, result) {
          console.log(result.imageDeleteResult);
          vm.imageList();
          // vm.veriler=JSON.parse(result.fileListResult)
          // vm.listImage=vm.veriler
          //vm.barkodOku(orderNumber.trim())
        });
      });
    },
    redListesi(orderNumber, lineItemId, sira) {
      //alert(orderNumber+' - '+lineItemId)

      // alert(this.sipariseGoreUrunListesi[sira].iadeAciklama)
      this.iadeOrderNumber = orderNumber;
      this.iadeLineItemId = lineItemId;
      this.popupActiveCikti = true;
      this.iadeTextarea = this.sipariseGoreUrunListesi[sira].iadeAciklama;
      this.imageList();
    },
    talebiGonder(orderNumber, lineItemId) {
      //console.log(orderNumber+' - '+lineItemId)

      var vm = this;

      const soap = require("soap");
      const url = state.sistemAddress;
      const secilenPazarYeri = this.selectedPazaryeri();
      // alert(this.pazaryeriVal)
      const args = {
        program: secilenPazarYeri,
        orderNumber: orderNumber,
        lineItemId: lineItemId,
      };
      soap.createClient(url, function (err, client) {
        client.iadeRedGonder(args, function (err, result) {
          vm.veriler = fixTurkishCharsDeep(JSON.parse(result.iadeRedGonderResult));
          console.log(vm.veriler);
        });
      });
    },
    lineIadeNedeniYaz(name, id) {
      var vm = this;
      var vs = this.$vs;
      const soap = require("soap");
      const url = state.sistemAddress;
      const secilenPazarYeri = this.selectedPazaryeri();
      const args = {
        pazaryeri: secilenPazarYeri,
        orderNumber: this.iadeOrderNumber,
        lineItemId: this.iadeLineItemId,
        token: Store.state.tokenId,
        nedeni: name,
        id: id,
        aciklama: this.iadeTextarea,
      };
      soap.createClient(url, function (err, client) {
        client.iadeNedeniSatir(args, function (err, result) {
          if (result.iadeNedeniSatirResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          } else {
            vm.popupActiveCikti = false;
            vm.barkodOku();
            //vm.veriler=fixTurkishCharsDeep(JSON.parse(result.iadeKabulListesineEkleResult))
            //vm.barkodOku(orderNumber.trim())
          }
        });
      });
    },
    kabulListesineEkle(orderNumber, lineItemId, durum) {
      var vm = this;
      var vs = this.$vs;
      const soap = require("soap");
      const url = state.sistemAddress;
      const secilenPazarYeri = this.selectedPazaryeri();
      // alert(this.pazaryeriVal)
      const args = {
        pazaryeri: secilenPazarYeri,
        orderNumber: orderNumber,
        claimItemId: lineItemId,
        token: Store.state.tokenId,
        durum: durum,
      };
      //alert(lineItemId)
      soap.createClient(url, function (err, client) {
        client.iadeKabulListesineEkle(args, function (err, result) {
          if (result.iadeKabulListesineEkleResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          } else {
            vm.veriler = fixTurkishCharsDeep(JSON.parse(result.iadeKabulListesineEkleResult));
            vm.barkodOku(orderNumber.trim());
          }
        });
      });
    },
    secilenSiparisSil(gelenOrder) {
      var vm = this;
      var vs = this.$vs;
      const soap = require("soap");
      const url = state.sistemAddress;
      const secilenPazarYeri = this.selectedPazaryeri();
      // alert(this.pazaryeriVal)
      const args = {
        pazaryeri: secilenPazarYeri,
        orderNumber: gelenOrder,
        token: Store.state.tokenId,
      };
      soap.createClient(url, function (err, client) {
        client.iadeSiparisSil(args, function (err, result) {
          if (result.iadeSiparisSilResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          } else {
            vm.veriler = fixTurkishCharsDeep(JSON.parse(result.iadeSiparisSilResult));

            if (vm.veriler.response == "Ok") {
              vs.loading.close(
                "#button-with-loading-partile > .con-vs-loading"
              );
              vs.notify({
                title: "Sipariş Silindi",
                text: "Sipariş Silindi",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success",
                position: "top-center",
              });
            } else {
              vs.notify({
                title: "Sipariş Silinemedi",
                text: "Sipariş Silmede Hata Oluştu",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "error",
                position: "top-center",
              });
            }
          }
        });
      });
    },
    iadefaturaOlustur() {
      var vm = this;
      var vs = this.$vs;
      const closeLoading = () =>
        vs.loading.close("#button-with-loading > .con-vs-loading");
      vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: "#button-with-loading",
        scale: 0.45,
      });

      const soap = require("soap");
      const url = state.sistemAddress;
      const secilenPazarYeri = this.selectedPazaryeri();
      //alert(secilenPazarYeri)
      if (vm.recId == null) {
        vm.recId = 1;
      }

      const args = {
        orderNumber: vm.genelSiparisNo,
        program: secilenPazarYeri,
        token: Store.state.tokenId,
        EMPLOYEEID: Store.state.plasiyer,
      };
      console.log(args);
      soap.createClient(url, function (err, client) {
        if (err || !client) {
          closeLoading();
          vs.notify({
            title: "İade",
            text: "Bağlantı hatası",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "warning",
            position: "top-center",
          });
          return;
        }
        client.iadeFaturaYaz(args, function (err, result) {
          if (err || !result) {
            closeLoading();
            vs.notify({
              title: "İade",
              text: "İşlem hatası",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "warning",
              position: "top-center",
            });
            return;
          }
          if (result.iadeFaturaYazResult == "-1") {
            closeLoading();
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          } else {
            if (vm.recId == 0) {
              closeLoading();
              vs.notify({
                title: "Fatura",
                text: vm.veriler.message,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "warning",
                position: "top-center",
              });
              vm.validatedF = 0;
            } else {
              try {
                vm.veriler = fixTurkishCharsDeep(JSON.parse(result.iadeFaturaYazResult));
              } catch (e) {
                closeLoading();
                vs.notify({
                  title: "İade",
                  text: "Yanıt ayrışlamadı",
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "warning",
                  position: "top-center",
                });
                return;
              }
              if (vm.veriler.response == "Ok") {
                closeLoading();

                vm.validatedF = 0;
                vm.recId = 0;
                vm.receiptId = vm.veriler.ReceiptId;
                vm.faturaNo = vm.veriler.FaturaNo;
                vs.loading.close(
                  "#button-with-loading-partile > .con-vs-loading"
                );
                vs.notify({
                  title: "Fatura",
                  text: "İade İşlemi Başarılı",
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "success",
                  position: "top-center",
                });
                // document.getElementById("ciktiPdf").src=Store.state.printAddress+vm.receiptId.replace("'","")+"&Tr="+vm.pazaryeriVal;
                vm.imageLink = "";
                //  window.open(Store.state.printAddress+vm.receiptId.replace("'",""), "_blank");
                document.getElementById("barkodM").focus();
                vm.listeTemizle();
                vm.validated = 1;
              } else {
                closeLoading();
                vs.notify({
                  title: "İade",
                  text: vm.veriler.message,
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "warning",
                  position: "top-center",
                });
              }
            }
          }
        });
      });
    },
    print() {
      // Pass the element id here
      this.$htmlToPaper("printMe");
    },
    indexbul(array, conditionFn) {
      const item = array.find(conditionFn);
      return array.indexOf(item);
    },
    selectedPazaryeri(value = this.selected) {
      const pazaryeri =
        value && typeof value === "object" ? value.label || value.value : value;
      const pazaryeriText =
        typeof pazaryeri === "string" ? pazaryeri.trim() : pazaryeri;
      return pazaryeriText === "Tümü" ? "Tumu" : pazaryeriText;
    },
    ps1(text) {
      this.partiVal = text;
    },
    ps(text) {
      const partiNumalari = [];
      this.pazaryeriVal = text;
      partiNumalari.push("Tümü");
      this.pazaryeriTum.forEach((element) => {
        if (text == element.pazaryeri) {
          partiNumalari.push(element.partiNo2);
        }
      });
      this.optionsParti = partiNumalari;
    },
    iadeCek(sayfasayisi) {
      var vs = this.$vs;
      vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: "#button-with-loading-yeni-iade",
        scale: 0.45,
      });
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      const secilenPazarYeri = this.selectedPazaryeri();
      //alert(secilenPazarYeri)
      const args = {
        pazaryeri: secilenPazarYeri,
        listelenecekSayfa: sayfasayisi,
        token: Store.state.tokenId,
      };
      soap.createClient(url, function (err, client) {
        client.iadeSiparisCek(args, function (err, result) {
          if (result.iadeSiparisCekResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            vm.veriler = fixTurkishCharsDeep(JSON.parse(result.iadeSiparisCekResult));

            if (vm.veriler.response == "Ok") {
              vs.loading.close(
                "#button-with-loading-yeni-iade > .con-vs-loading"
              );
              if (parseInt(vm.veriler.page) < parseInt(vm.veriler.totalPages)) {
                vm.veriler.page = parseInt(vm.veriler.page) + 1;
                const percent = 100 / parseInt(vm.veriler.totalPages);
                vm.progress = percent * vm.veriler.page;
                vm.iadeSiparisCek(vm.veriler.page);
              } else {
                vs.loading.close(
                  "#button-with-loading-yeni-iade > .con-vs-loading"
                );
                vs.notify({
                  title: secilenPazarYeri,
                  text: vm.veriler.message || "İadeler Çekiliyor",
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "success",
                  position: "top-center",
                });
              }
            } else {
              vs.loading.close(
                "#button-with-loading-yeni-iade > .con-vs-loading"
              );
              vs.notify({
                title: secilenPazarYeri,
                text: vm.veriler.message || "İadeler Çekilemedi",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: vm.veriler.message ? "warning" : "red",
                position: "top-center",
              });
            }
          } catch (error) {
            vs.loading.close(
              "#button-with-loading-yeni-iade > .con-vs-loading"
            );
          }
        });
      });
    },

    secilenPartiUrunleri() {
      const vs = this.$vs;

      if (this.pazaryeriVal == "" || this.partiVal == "") {
        vs.notify({
          title: "Paketleme",
          text: "Pazaryerini ve Parti Seçiniz",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center",
        });
      } else {
        var vm = this;

        const soap = require("soap");
        const url = state.sistemAddress;

        const args = {
          pazaryeri: this.selectedPazaryeri(this.pazaryeriVal),
          partiNo: this.partiVal,
          token: Store.state.tokenId,
        };
        soap.createClient(url, function (err, client) {
          client.partiUrunleri(args, function (err, result) {
            if (result.partiUrunleriResult == "-1") {
              Store.dispatch("logout");
              //this.$store.dispatch('login', payload)
            } else {
              vm.veriler = fixTurkishCharsDeep(JSON.parse(result.partiUrunleriResult));
              vm.total = vm.veriler[0]["tt"];
              vm.list = vm.veriler;

              vm.popupActive = true;
            }
          });
        });
      }
    },
    siparisBul() {
      var vm = this;

      const soap = require("soap");
      const url = state.sistemAddress;
      // alert(this.pazaryeriVal)
      const args = {
        pazaryeri: vm.selectedPazaryeri(),
        token: Store.state.tokenId,
        sayfa: 0,
        orderNumber: this.siparisBulOrderNumber,
      };
      soap.createClient(url, function (err, client) {
        client.iadeListele(args, function (err, result) {
          if (result.iadeListeleResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          } else {
            vm.veriler = fixTurkishCharsDeep(JSON.parse(result.iadeListeleResult));
            vm.listSiparis = vm.veriler;
            vm.popupActiveSiparis = true;
          }
        });
      });
    },
    siparisSec() {
      var vm = this;
      console.log(vm.selected);
      const soap = require("soap");
      const url = state.sistemAddress;
      // alert(this.pazaryeriVal)
      const args = {
        pazaryeri: vm.selectedPazaryeri(),
        token: Store.state.tokenId,
        sayfa: 0,
        orderNumber: "",
      };
      soap.createClient(url, function (err, client) {
        client.iadeListele(args, function (err, result) {
          if (result.iadeListeleResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          } else {
            vm.veriler = fixTurkishCharsDeep(JSON.parse(result.iadeListeleResult));
            vm.listSiparis = vm.veriler;
            vm.popupActiveSiparis = true;
          }
        });
      });
    },
    barkodOku(gelenorder) {
      // alert(gelenorder)
      const vm = this;
      const vs = this.$vs;
      const kontrol = 0;

      vm.sipariseGoreUrunListesi = "";
      const soap = require("soap");
      const url = state.sistemAddress;
      //console.log(this.pazaryeriVal.trim()+"**"+this.partiVal+"**"+vm.barkod+"**"+this.aski+"**"+gelenorder+"**"+Store.state.tokenId)
      //  alert(vm.barkod)
      const args = {
        barkod: vm.barkod,
        orderNumber: gelenorder,
        token: Store.state.tokenId,
      };
      console.log(args);
      soap.createClient(url, function (err, client) {
        client.iadeUrun(args, function (err, result) {
          if (result.iadeUrunResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = fixTurkishCharsDeep(JSON.parse(result.iadeUrunResult));
          console.log("vm.veriler" + " " + vm.veriler);
          if (vm.veriler.response == "No") {
            vs.notify({
              title: "İade",
              text: "Okutulan Ürün&Barkod İade Listesinde Yok",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "warning",
              position: "top-center",
            });
          } else {
            vm.genelSiparisNo = vm.veriler[0].orderNumber;
            vm.faturaNo = vm.veriler[0].faturaNo;
            vm.genelKargoAdi = vm.veriler[0].cargoProviderName;
            vm.genelKargoNo = vm.veriler[0].cargoTrackingNumber;
            vm.genelToplam = vm.veriler[0].grossAmount;
            vm.genelMusteri =
              vm.veriler[0].shipFirstName + " " + vm.veriler[0].shipLastName;
            vm.hediyeMi = vm.veriler[0].hediyeMi;
            vm.recId = vm.veriler[0].siparisKayit;
            vm.sipariseGoreUrunListesi = vm.veriler;
            vm.iadeTextarea = vm.veriler[0].iadeAciklama;
            vm.indext = vm.indexbul(
              vm.sipariseGoreUrunListesi,
              (item) => item.barcode === vm.barkod
            );

            vm.iadeNedenleri();
          }

          document.getElementById("barkodM").focus();
        });
      });

      //alert(this.barkod)
    },
    imageShow(sku) {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = { stokKodu: sku, token: Store.state.tokenId };
      soap.createClient(url, function (err, client) {
        client.resimGoruntule(args, function (err, result) {
          if (result.resimGoruntuleResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = JSON.parse(result.resimGoruntuleResult);
          if (vm.veriler.length > 0) {
            vm.imageLink = vm.veriler[0]["STOCKPICTURE"];
          }
        });
      });
    },
    iadeNedenleri() {
      const vs = this.$vs;
      const vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      const secilenPazarYeri = this.selectedPazaryeri();
      const args = { token: Store.state.tokenId, program: secilenPazarYeri };
      soap.createClient(url, function (err, client) {
        client.iadeNedenleri(args, function (err, result) {
          if (result.iadeNedenleriResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          const gelenVeri = result.iadeNedenleriResult;
          vm.veriler = JSON.parse(gelenVeri);
          // console.log(vm.veriler.json)
          //vm.options=vm.veriler.json
          vm.listSiparis = vm.veriler.json;
        });
      });
    },
    stokGuncelle() {
      const vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      const secilenPazarYeri = this.selectedPazaryeri();
      const args = { program: secilenPazarYeri, token: Store.state.tokenId };
      soap.createClient(url, function (err, client) {
        client.stokAdetFiyatGuncelle(args, function (err, result) {
          if (result.stokAdetFiyatGuncelleResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = fixTurkishCharsDeep(JSON.parse(result.stokAdetFiyatGuncelleResult));
        });
      });
    },
    tekrarIslemeAl(orderNumber, merchantSku, partiNo) {
      var vm = this;

      const soap = require("soap");
      const url = state.sistemAddress;
      // alert(this.pazaryeriVal)
      const args = {
        pazaryeri: this.selectedPazaryeri(this.pazaryeriVal),
        token: Store.state.tokenId,
        orderNumber: orderNumber,
      };
      soap.createClient(url, function (err, client) {
        client.tekrarIslemeAl(args, function (err, result) {
          if (result.siparisListeleResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          } else {
            vm.siparisHazirla(orderNumber, merchantSku, partiNo);
          }
        });
      });
    },
    siparisHazirla(orderNumber, merchantSku, partiNo) {
      // alert(orderNumber+" "+merchantSku+" "+partiNo)
      // this.partiVal=partiNo
      this.barkod = merchantSku;
      this.ilkOkuma = 1;
      this.barkodOku(orderNumber.trim());
      this.popupActiveSiparis = false;
    },
    listeTemizle() {
      this.sipariseGoreUrunListesi = [];
      this.validated = 1;
      this.eklenenToplamParca = 0;
    },
  },
  beforeMount() {
    //  console.log(Store.state.UserId)
    //setInterval(this.stokGuncelle,900000);
  },
};
</script>
<style lang="scss" scoped>
.mb-base {
  margin-bottom: 0.75rem !important;
}
.list-view-item {
  .item-name,
  .item-description {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .item-name {
    -webkit-line-clamp: 2;
  }

  .item-description {
    -webkit-line-clamp: 5;
  }

  .grid-view-img {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    transition: 0.35s;
  }

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.25);

    .grid-view-img {
      opacity: 0.9;
    }
  }
}
img {
  width: 30%;
  margin: auto;
  display: block;
  margin-bottom: 10px;
}
</style>
